export const mainArray = ({ dropDowns }) => [
  {
    id: "user",
    name: "user",
    type: "text",
    label: "User ID",
  },
  {
    id: "jobName",
    name: "jobName",
    type: "text",
    label: "Job Name",
    options: dropDowns?.backgroundJobNames || [],
    tag: "select",
  },
  {
    id: "jobIdentifier",
    name: "jobIdentifier",
    type: "text",
    label: "Job Identifier",
    options: dropDowns?.backgroundJobIdentifiers || [],
    tag: "select",
  },
  {
    id: "startDT",
    name: "startDT",
    type: "datetime",
    label: "Start DT",
  },
  {
    id: "endDT",
    name: "endDT",
    type: "datetime",
    label: "End DT",
  },
  {
    id: "jobEndStatus",
    name: "jobEndStatus",
    type: "number",
    label: "Job End Status",
  },
  {
    id: "jobInProcess",
    name: "jobInProcess",
    type: "checkbox",
    label: "Job In Process",
    tag: "checkbox",
  },
];
